export const screenSizeBiggerOrEqual = (screenSize: ScreenSize) => window.innerWidth >= screenSize;

export const isSmall = (size: string) => size === 'small';
export const isLargeOrSmaller = (size: string) => ['small', 'medium', 'large'].includes(size);

export enum ScreenSize {
  TABLET_LANDSCAPE = 1024,
}
const MAX_CONTENT_WIDTH = '1440px';

export { MAX_CONTENT_WIDTH };
